<script setup>
import { usePage } from '@inertiajs/vue3';

const {
  props: {
    business: { name, logo },
  },
} = usePage();
</script>

<template>
  <nav class="tw-mb-2 tw-flex tw-w-full tw-justify-center tw-bg-white tw-px-6 tw-py-3 tw-shadow-md">
    <div
      class="tw-flex tw-w-full tw-max-w-6xl tw-flex-col tw-items-center tw-space-y-4 md:tw-flex-row md:tw-space-y-0 print:tw-flex-row print:tw-space-y-0"
      :class="[logo ? 'tw-justify-between' : 'tw-justify-center']"
    >
      <div v-if="logo">
        <img :src="logo" :alt="name" class="tw-max-h-16 tw-max-w-xs" />
      </div>
      <div
        class="tw-max-w-full tw-truncate tw-pl-3 tw-text-center tw-text-2xl tw-font-bold tw-tracking-wide md:tw-text-right"
      >
        {{ name }}
      </div>
    </div>
  </nav>
</template>
